export function isImageOnlyReviewPath(pathname: string): boolean {
  return /^\/batches\/[^/]+\/images$/.test(pathname);
}

export function isDashboardWallboardPath(pathname: string, search = ''): boolean {
  return pathname === '/dashboard' && new URLSearchParams(search).get('display') === 'wallboard';
}

export function isOperationsWallboardPath(pathname: string, search = ''): boolean {
  return (
    pathname === '/admin/operations' && new URLSearchParams(search).get('display') === 'wallboard'
  );
}

export function isWallboardPath(pathname: string, search = ''): boolean {
  return (
    pathname === '/wallboard' ||
    isDashboardWallboardPath(pathname, search) ||
    isOperationsWallboardPath(pathname, search)
  );
}

export function isFullWidthWorkbenchPath(pathname: string, search = ''): boolean {
  const inventorySection =
    pathname === '/storage' ? new URLSearchParams(search).get('section') : undefined;
  const isContainerBrowseSection =
    typeof inventorySection === 'string' &&
    ['Racks', 'Shelves', 'Boxes', 'Rows', 'Batches'].includes(inventorySection);
  return (
    pathname === '/sales' ||
    pathname.startsWith('/sales/') ||
    pathname === '/consignment' ||
    isWallboardPath(pathname, search) ||
    isContainerBrowseSection ||
    /^\/batches\/[^/]+\/identify$/.test(pathname) ||
    isImageOnlyReviewPath(pathname)
  );
}
